/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Yoga = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 30 25">
      <path
        d="M28,22.4379 L9.285,22.4379 C9.983,21.5529 10.417,20.4509 10.417,19.2379 L10.417,19.2359 L10.417,19.2349 L10.378,6.5949 L28,6.5949 L28,22.4379 Z M2.017,19.2379 C2.017,17.4739 3.453,16.0379 5.217,16.0379 C6.982,16.0379 8.417,17.4739 8.417,19.2379 C8.417,21.0019 6.982,22.4379 5.217,22.4379 C3.453,22.4379 2.017,21.0019 2.017,19.2379 L2.017,19.2379 Z M5.186,1.9999 C6.943,1.9999 8.373,3.3269 8.373,4.9609 L8.405,15.1599 C7.521,14.4679 6.424,14.0379 5.217,14.0379 C4.002,14.0379 2.898,14.4739 2.012,15.1749 L2,4.8829 C2.042,3.2929 3.471,1.9999 5.186,1.9999 L5.186,1.9999 Z M29,4.5949 L10.334,4.5949 C10.136,2.0329 7.916,-0.0001 5.186,-0.0001 C2.35,-0.0001 0.072,2.1219 0,4.8579 L0.017,19.2389 L0.017,19.2399 C0.019,21.9799 2.157,24.2079 4.849,24.4009 C4.911,24.4129 4.968,24.4379 5.033,24.4379 L29,24.4379 C29.552,24.4379 30,23.9899 30,23.4379 L30,5.5949 C30,5.0429 29.552,4.5949 29,4.5949 L29,4.5949 Z"
        id="icon/wellness/yoga"
      />
    </BaseSvgIcon>
  )
}

export default Yoga
